import { type NodeRenderer } from '@contentful/rich-text-react-renderer'
import clsx from 'clsx/lite'
import React from 'react'

export const documentGrid: NodeRenderer = (node, children) => (
  <h2
    className={clsx(
      'mb-3 text-center text-180 leading-alternate tablet:text-200',
      'group-[.is-refresh]/section-template:text-[44px]/[52px] group-[.is-refresh]/section-template:!font-normal',
      'group-[.is-blue]/section-template:text-text-inverse',
      'group-[.is-premium-black]/section-template:text-[#ffffff]'
    )}
  >
    {children}
  </h2>
)
